<div class="ickahra kareli">
  <div class="sar">
    <p class="etiket">Öğretmenler</p>
    <h1 class="h1" style="margin-top:16px">Kim neyi unutuyor, <span class="vurgu">tek ekranda</span>.</h1>
    <p class="giris-p">Sınıfını kur, soruyu bankadan seç, ata. Tekrar planı kendi kendine döner. Sana kalan iş, sınıfça çürüyen kazanıma bakıp dersini ona göre kurmak.</p>
    <div class="hero-btn">
      <a class="btn kirmizi" href="https://app.pratiu.com" target="_blank" rel="noopener">Hemen kayıt olun <svg><use xlink:href="#i-ok"></use></svg></a>
      <a class="btn ikincil" href="https://app.pratiu.com" target="_blank" rel="noopener">Paneli gör</a>
    </div>
    <div class="sayac">
      <div><span class="sayi">10 dk</span><span class="etiket">ilk sınavı atama süresi</span></div>
      <div><span class="sayi">10.000</span><span class="etiket">soru</span></div>
      <div><span class="sayi">8</span><span class="etiket">panel ekranı</span></div>
    </div>
  </div>
</div>

<div class="sar bol">
  <div class="bol-bas"><span class="etiket">Panel</span><h2 class="h2">Sekiz ekran, tek akış.</h2></div>
  <div class="g4">
    <div class="ozet"><div class="rk"><svg><use xlink:href="#i-sinif"></use></svg></div><h4 class="h4">Sınıflar ve öğrenciler</h4><p>Listeyi Excel'den içe aktar, öğrenci hesapları otomatik açılsın.</p></div>
    <div class="ozet"><div class="rk"><svg><use xlink:href="#i-soru"></use></svg></div><h4 class="h4">Sorular</h4><p>Kazanım ve süreye göre filtrele. Kendi sorunu görseliyle ekle.</p></div>
    <div class="ozet"><div class="rk"><svg><use xlink:href="#i-sinav"></use></svg></div><h4 class="h4">Sınavlar</h4><p>Seçtiğin sorulardan sınav kur, süresini ve karışık sırayı ayarla.</p></div>
    <div class="ozet"><div class="rk"><svg><use xlink:href="#i-atama"></use></svg></div><h4 class="h4">Atama</h4><p>Sınıfa ata, bitiş tarihini ver, tekrar planını aç. Gerisi döngüye girer.</p></div>
    <div class="ozet"><div class="rk"><svg><use xlink:href="#i-ders"></use></svg></div><h4 class="h4">Dersler</h4><p>Ders ve konu ağacını kendi planına göre düzenle.</p></div>
    <div class="ozet"><div class="rk"><svg><use xlink:href="#i-grafik"></use></svg></div><h4 class="h4">Kazanım raporu</h4><p>Sınıf ortalaması değil, kazanım kırılımı. Zayıf konu kendini gösterir.</p></div>
    <div class="ozet"><div class="rk"><svg><use xlink:href="#i-duyuru"></use></svg></div><h4 class="h4">Duyurular</h4><p>Sınıfa tek mesaj. Okuyanı ve okumayanı gör.</p></div>
    <div class="ozet"><div class="rk"><svg><use xlink:href="#i-kv"></use></svg></div><h4 class="h4">Yapay zekâ taslakları</h4><p>Özgün sorudan varyasyon üret, onayla, bankana ekle.</p></div>
  </div>
</div>

<div style="border-top:1px solid var(--cizgi);background:var(--kagit-2)">
  <div class="sar bol">
    <div class="aciklama">
      <div>
        <span class="etiket">Nasıl kurulur</span>
        <h2 class="h2" style="margin:14px 0 18px">İlk dersten önce üç adım.</h2>
        <ul class="tik">
          <li><svg><use xlink:href="#i-tik"></use></svg><span><b>Sınıfını oluştur.</b> Öğrenci listesini yapıştır, sınıf kodu üretilsin.</span></li>
          <li><svg><use xlink:href="#i-tik"></use></svg><span><b>Kazanımını seç.</b> Bu hafta işlediğin konuyu işaretle, soru havuzu kendiliğinden filtrelensin.</span></li>
          <li><svg><use xlink:href="#i-tik"></use></svg><span><b>Atamayı yap.</b> Tekrar planını açık bırak; sistem bir daha sormanı beklemez.</span></li>
        </ul>
      </div>
      <div class="kart">
        <div class="kart-bas"><h3 class="h3">Çürüyen kazanımlar</h3><span class="rozet kr">7</span></div>
        <div>
          <div style="display:flex;align-items:center;gap:14px;padding:13px 16px;border-bottom:1px solid var(--kagit-3)">
            <div style="flex:1"><b style="font-size:14px">M.8.1.2.1 · Çarpanlar ve katlar</b><p class="soluk" style="font-size:12.5px">8-A · 19 öğrencide düşüş</p></div>
            <div class="guc zayif"><i class="d"></i><i class="d"></i><i></i><i></i><i></i></div>
          </div>
          <div style="display:flex;align-items:center;gap:14px;padding:13px 16px;border-bottom:1px solid var(--kagit-3)">
            <div style="flex:1"><b style="font-size:14px">M.8.1.1.2 · Üslü ifadelerde işlem</b><p class="soluk" style="font-size:12.5px">8-A, 8-C · 23 öğrencide düşüş</p></div>
            <div class="guc zayif"><i class="d"></i><i></i><i></i><i></i><i></i></div>
          </div>
          <div style="display:flex;align-items:center;gap:14px;padding:13px 16px">
            <div style="flex:1"><b style="font-size:14px">M.7.1.4.3 · Rasyonel sayılarla işlem</b><p class="soluk" style="font-size:12.5px">7-B · 14 öğrencide düşüş</p></div>
            <div class="guc zayif"><i class="d"></i><i class="d"></i><i></i><i></i><i></i></div>
          </div>
        </div>
        <div style="padding:13px 16px;border-top:1px solid var(--cizgi)">
          <a class="btn ikincil k" href="https://app.pratiu.com" target="_blank" rel="noopener" style="width:100%;justify-content:center">Panelde aç</a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="cta">
  <div class="cta-ic">
    <div><h2 class="h2">Sınıfını bu hafta kur.</h2><p>Okul e-postanla gir, listeyi yapıştır, ilk atamayı yap.</p></div>
    <a class="btn kirmizi" href="https://app.pratiu.com" target="_blank" rel="noopener">Hemen kayıt olun <svg><use xlink:href="#i-ok"></use></svg></a>
  </div>
</div>
